import { ITooltipParams } from 'ag-grid-community'

interface AgCustomTooltipProps extends ITooltipParams {
  alwaysShowTooltip: boolean
}

export class AgCustomTooltipRenderer {
  agParams!: AgCustomTooltipProps
  eGui!: HTMLDivElement

  getContainerClasses() {
    return ['custom-tooltip']
  }

  init(agParams: AgCustomTooltipProps) {
    this.agParams = agParams
    this.eGui = document.createElement('div')
    this.eGui?.classList.add('custom-tooltip')

    // Show tooltip if alwaysShowTooltip is true or if column width might be insufficient
    if (this.agParams.alwaysShowTooltip || this.agParams.value) {
      this.eGui.innerHTML = `<div class="tooltip-text">${this.agParams.value}</div>`
    } else {
      this.eGui.innerHTML = ''
    }
  }

  getGui() {
    return this.eGui
  }
}
